/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsAdminShiftOutput } from "../../entities/models/AdminShiftOutput";
import { z } from "zod/v4";

export const modelsAdminShiftOutputSchema = z.object({
    "barber_id": z.optional(z.int()),
"barber_name": z.optional(z.string()),
"can_start": z.optional(z.boolean()),
"created_at": z.optional(z.string()),
"current_status": z.optional(z.enum(["free", "busy", "break"])),
"end_time": z.optional(z.string()),
"shift_id": z.optional(z.int()),
"start_time": z.optional(z.string()),
"station_id": z.optional(z.int()),
"station_name": z.optional(z.string()),
"status": z.optional(z.enum(["scheduled", "active", "ended", "cancelled"]))
    }) as unknown as z.ZodType<ModelsAdminShiftOutput>